import {Action} from 'redux'

import {
	REQUEST_MY_PROFILE, RECEIVE_MY_PROFILE, TOGGLE_ACCOUNT_OVERLAY,
	CLOSE_ACCOUNT_OVERLAY, MY_PROFILE_ERROR, UPDATE_AVATAR_ID
} from '../player/ProfileActions'
import {PlayerProfile} from '../../communication/PlayerApiProtocol.generated'
import {
	assign, AsyncState, ReduxAction, AsyncStatus, handleAsyncError, handleAsyncRequest,
	createAsyncState
} from '../ReduxUtils'
import {appCtx} from '../../ApplicationContext'
import {myPlayer} from '../../MyPlayer'


export interface PlayerProfileState extends AsyncState {
    externalUserId? : string;
    avatarId? : string;
    broadcaster? : boolean;
    attributes? : any;
    level? : number;
    name? : string;
    avatarUrl? : string;
    showAccountOverlay? : boolean;
}



const initialProfile : PlayerProfileState  = createAsyncState({ showAccountOverlay : false})

/**
 * Profile reducer, managing PlayerProfileState part of the application state
 * @param state
 * @param action
 * @returns {PlayerProfileState}
 */
export function profileReducer(state : PlayerProfileState = initialProfile, anAction : Action) : PlayerProfileState {
	var action : ReduxAction<any> = anAction as ReduxAction<any>

	switch (action.type) {
	case TOGGLE_ACCOUNT_OVERLAY:
		return assign<PlayerProfileState>({}, state, {
			lastRequested: action.createdTime,
			showAccountOverlay : !state.showAccountOverlay
		})
	case CLOSE_ACCOUNT_OVERLAY:
		return assign<PlayerProfileState>({}, state, {
			lastRequested: action.createdTime,
			showAccountOverlay : false
		})

	case MY_PROFILE_ERROR:
		return handleAsyncError(state)

	case REQUEST_MY_PROFILE:
		return handleAsyncRequest(state,action)

	case UPDATE_AVATAR_ID:
		return assign<PlayerProfileState>({}, state, {
			avatarId : action.payload
		})
	case RECEIVE_MY_PROFILE:
		return handleReceiveProfile(action, state)
	default:
		return state                                  
	}
}

/**
 * Handle PlayerProfile response
 */
const handleReceiveProfile = (action:ReduxAction<PlayerProfile>, state:PlayerProfileState) => {
	let profile = action.payload

	var name = extractName(action.payload)

	let avatarUrl = extractAvatarUrl(action.payload, window.location)

	let avatarId = ''
	var avatarManager = appCtx.getAvatarManager()
	avatarId = profile.avatarId
	if (avatarId == null || avatarId == '') {
		avatarId = avatarManager.getValidAvatarId(avatarId, myPlayer.id)
	}

	let attributes = profile.attributes

	if (profile.level) {
		attributes = Object.assign({}, attributes, {level : profile.level})
	}

	var newState : PlayerProfileState =  {
		name : name,
		avatarUrl : avatarUrl,
		externalUserId: profile.externalUserId,
		avatarId: avatarId,
		broadcaster: profile.broadcaster,
		attributes: attributes,
		level : profile.level,
		status : AsyncStatus.COMPLETED,
		lastReceived: action.createdTime
	}
	return assign<PlayerProfileState>({}, state, newState)
}


// Returns the avatar url if the protocol of the URL is valid for the location parameter
export function extractAvatarUrl(profile : PlayerProfile, location : Location) : string {
	if (profile.externalAvatarUrl != null && location.protocol === 'http:' || (profile.externalAvatarUrl!=null && location.protocol === 'https:' && profile.externalAvatarUrl.indexOf('https:') == 0)) {
		return profile.externalAvatarUrl
	}
	return undefined
}

export function extractName(profile : PlayerProfile) : string {
	var name = ''
	if (typeof(profile.screenname)!=='undefined') {
		name = profile.screenname
	} else if (typeof(profile.externalUsername)!=='undefined') {
		name = profile.externalUsername
	} else if (typeof(profile.username)!=='undefined') {
		name = profile.username
	}
	return name
}
